/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React from 'react';

import {batch, connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import Diagram from '@/components/diagram/Diagram';
import * as APPDATA from '@/constants/pcConstAppData';
import * as COMMONFUNCTION from '@/libs/appHelper';
import convertCleaningStatusToDisplayString from '@/libs/cleaningWizardHelper';
import {SecondToStringFormat, TimeRemaining} from '@/libs/dateHelper';

import {INITIAL_CUSTOM_OPERATION} from '../../../stores/reducers/setupStore';

@connect((store) => ({
  CurrentPCState: store.setupStore.currentPCState,
  cleaningProperties: store.setupStore.cleaningProperties,
  // topButtonProperties: store.setupStore.topButtonProperties,
  backButtonProperties: store.setupStore.backButtonProperties,
  cleaningCustomOperation: store.setupStore.cleaningCustomOperation,
}))
class StatusWizard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      operations: undefined,
      totalDuration: '',
      timeRemaining: '',
      status: APPDATA.DEVICE_STATE.IDLE,
      recomendedVolume: props.cleaningProperties.cleaningSolution,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {
    clearInterval(this._cleaningWizardPooling);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {cleaningCustomOperation, CurrentPCState, cleaningProperties, backButtonProperties} = nextProps;
    const {status} = prevState;

    const currentRunningSequence = cleaningCustomOperation.Operations.find((operation) => operation.Running);
    const currentRunningStatus =
      CurrentPCState === APPDATA.DEVICE_STATE.IDLE && cleaningCustomOperation.Status === APPDATA.DEVICE_STATE.IDLE
        ? APPDATA.DEVICE_STATE.IDLE
        : currentRunningSequence !== undefined
        ? currentRunningSequence.Sequence.replace('_', ' ').toUpperCase()
        : APPDATA.DEVICE_STATE.PREPARING;

    if (currentRunningStatus !== status) {
      if (cleaningCustomOperation.Message && !COMMONFUNCTION.IsEmpty(cleaningCustomOperation.Message)) {
        batch(() => {
          nextProps.dispatch(setupActions.prevActionWizard(true));
          nextProps.dispatch(
            setupActions.setCleaningProperties({
              ...cleaningProperties,
              isCleaningWizardRunning: false,
            }),
          );
          nextProps.dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: cleaningCustomOperation.Message,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );

          if (cleaningProperties.isCleaningWizardRunning && currentRunningStatus === APPDATA.DEVICE_STATE.IDLE) {
            const resetCleaningProperties = {
              isCleaningWizardRunning: false,
              cleaningDuration: undefined,
              cleaningSolution: 25,
              valveChipType: 6,
              [APPDATA.KEY.MembraneCutOffSize]: undefined,
            };
            nextProps.dispatch(setupActions.setCleaningProperties(resetCleaningProperties));
            window.location.href = APPDATA.CLEANING_WIZARD_ADDRESS;
            nextProps.dispatch(setupActions.SetCleaningCustomOperation(INITIAL_CUSTOM_OPERATION));
          }
        });
      } else {
        switch (currentRunningStatus) {
          case APPDATA.DEVICE_STATE.IDLE:
            batch(() => {
              nextProps.dispatch(
                setupActions.setCleaningProperties({
                  ...cleaningProperties,
                  isCleaningWizardRunning: false,
                }),
              );

              nextProps.dispatch(setupActions.nextActionWizard(true));
              nextProps.dispatch(loadingActions.showLoading(false));
            });
            break;

          default:
            batch(() => {
              if (!cleaningProperties.isCleaningWizardRunning)
                nextProps.dispatch(
                  setupActions.setCleaningProperties({
                    ...cleaningProperties,
                    isCleaningWizardRunning: true,
                  }),
                );

              if (!backButtonProperties.disabled)
                nextProps.dispatch(
                  setupActions.backButtonProperties({
                    ...backButtonProperties,
                    disabled: true,
                  }),
                );

              // nextProps.dispatch(setupActions.topButtonProperties({
              //   ...topButtonProperties,
              //   id: APPDATA.STOP,
              //   label: APPDATA.STOP.toUpperCase(),
              //   disabled: false
              // }));
            });
            break;
        }
      }
    }

    return {
      ...prevState,
      operations: cleaningCustomOperation.Operations,
      status:
        cleaningCustomOperation.Status === APPDATA.DEVICE_STATE.DEPRESSURIZING
          ? cleaningCustomOperation.Status
          : currentRunningStatus,
      timeRemaining: TimeRemaining(
        cleaningProperties.cleaningDuration * 60,
        cleaningCustomOperation.TimeElapsed / 1000,
      ),
      totalDuration: SecondToStringFormat(cleaningProperties.cleaningDuration * 60),
      recomendedVolume: cleaningProperties.cleaningSolution,
    };
  }

  // /**
  //  * @deprecated
  //  * @param {*} self
  //  * @param {*} response
  //  */
  // initialStatusWizard = ( response) => {
  //   const { cleaningProperties, backButtonProperties, topButtonProperties } = this.props;
  //   var tempTopButtonProperties = topButtonProperties;
  //   if (response.data.Status !== "IDLE") {
  //     //Cleaning Wizard is running
  //     var tempCleaningProperties = cleaningProperties;
  //     tempCleaningProperties.isCleaningWizardRunning = true;
  //     this.props.dispatch(setupActions.setCleaningProperties(tempCleaningProperties));

  //     tempTopButtonProperties.id = APPDATA.STOP;
  //     tempTopButtonProperties.label = APPDATA.STOP.toUpperCase();
  //     tempTopButtonProperties.disabled = false;
  //     this.props.dispatch(setupActions.topButtonProperties(tempTopButtonProperties));
  //     this.setStatusWizard(response);
  //   } else {
  //     tempTopButtonProperties.id = APPDATA.RUN;
  //     tempTopButtonProperties.label = APPDATA.RUN.toUpperCase();
  //     tempTopButtonProperties.disabled = false;
  //     this.props.dispatch(setupActions.topButtonProperties(tempTopButtonProperties));
  //   }
  // };

  // /**
  //  * @deprecated
  //  */
  // setStatusWizard = (response) => {
  //   const { cleaningProperties } = this.props;
  //   this.setState(
  //     {
  //       timeRemaining: this.generateTimeRemaining(cleaningProperties.cleaningDuration * 60, response.data.TimeElapsed / 1000),
  //       totalDuration: this.secondToMinute(cleaningProperties.cleaningDuration * 60),
  //       status: response.data.Status === STATUS.DEPRESSURIZING ? STATUS.DEPRESSURIZING : this.getStateName(response.data.Operations),
  //     }
  //     // () => {
  //     //     const { backButtonProperties, topButtonProperties } = this.props;

  //     //     var tempTopButtonProperties = topButtonProperties;
  //     //     if (!topButtonProperties.disabled && this.state.status === "PRESSURE CHANGES") {
  //     //         tempTopButtonProperties.disabled = true;
  //     //         ConsoleLog("setStatusWizard", this.state.status, tempTopButtonProperties);
  //     //         this.props.dispatch(setupActions.topButtonProperties(tempTopButtonProperties));
  //     //     } else if (topButtonProperties.disabled && this.state.status !== "PRESSURE CHANGES") {
  //     //         tempTopButtonProperties.disabled = false;
  //     //         ConsoleLog("setStatusWizard", this.state.status, tempTopButtonProperties);
  //     //         this.props.dispatch(setupActions.topButtonProperties(tempTopButtonProperties));
  //     //     }
  //     // }
  //   );
  // };

  // /**
  //  * @deprecated since the status update was published with signalR web-scoket
  //  * @param {*} statusResponse
  //  */
  // getStatus = (statusResponse) => {
  //   Get( APPDATA.API.GET_STATUS_CLEANING_WIZARD, "", statusResponse, "", this.failedGetStatus);
  // };

  // /**
  //  * @deprecated since the status update was published with signalR web-scoket
  //  * @param {*} self
  //  * @param {*} response
  //  * @returns
  //  */
  // successGetStatus = ( response) => {
  //   if (!this._isRunning) return;
  //   const { cleaningProperties, backButtonProperties, topButtonProperties } = this.props;
  //   if (response.data.Status !== "IDLE") {
  //     ConsoleLog("successGetStatus", response.data, cleaningProperties);
  //     if (!cleaningProperties.isCleaningWizardRunning) {
  //       var tempCleaningProperties = cleaningProperties;
  //       tempCleaningProperties.isCleaningWizardRunning = true;
  //       this.props.dispatch(setupActions.setCleaningProperties(tempCleaningProperties));
  //     }
  //     if (!backButtonProperties.disabled) {
  //       var tempBackButtonProperties = backButtonProperties;
  //       tempBackButtonProperties.disabled = true;
  //       this.props.dispatch(setupActions.backButtonProperties(tempBackButtonProperties));
  //     }
  //     if (response.data.Message !== "") {
  //       this.cleaningError(response.data);
  //       return;
  //     }

  //     this.setState({
  //       operations: response.data.Operations,
  //     });
  //     this.setStatusWizard(response);
  //   } else if (cleaningProperties.isCleaningWizardRunning && response.data.Status === "IDLE") {
  //     if (response.data.Message !== "") {
  //       this.cleaningError(response.data);
  //       window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
  //       return;
  //     }
  //     var tempCleaningProperties = cleaningProperties;
  //     tempCleaningProperties.isCleaningWizardRunning = false;
  //     this.props.dispatch(setupActions.setCleaningProperties(tempCleaningProperties));
  //     // if (backButtonProperties.disabled) {
  //     //     var tempBackButtonProperties = backButtonProperties;
  //     //     tempBackButtonProperties.disabled = false;
  //     //     this.props.dispatch(setupActions.backButtonProperties(tempBackButtonProperties));
  //     // }
  //     if (this.checkIsCycleComplete(response.data.Operations)) {
  //       //when iddle after running, cleaning wizard is done, go to success
  //       this.props.dispatch(setupActions.nextActionWizard(true));
  //     } else {
  //       this.props.dispatch(setupActions.nextActionWizard(true));
  //       this.props.dispatch(loadingActions.showLoading(false));
  //       // window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
  //     }
  //   }
  // };

  // /**
  //  * @deprecated
  //  */
  // checkIsCycleComplete = (sequences) => {
  //   for (var sequence of sequences) {
  //     if (sequence.Repeat !== sequence.Repeated) return false;
  //   }

  //   return true;
  // };

  // /**
  //  * @deprecated
  //  */
  // cleaningError = (data) => {
  //   this.props.dispatch(setupActions.prevActionWizard(true));

  //   var tempCleaningProperties = this.props.cleaningProperties;
  //   tempCleaningProperties.isCleaningWizardRunning = false;
  //   this.props.dispatch(setupActions.setCleaningProperties(tempCleaningProperties));
  //   this.props.dispatch(
  //     setupActions.showAlert({
  //       alertShow: true,
  //       alertText: data.Message,
  //       alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
  //     })
  //   );
  //   this.setState({
  //     status: "ERROR",
  //   });
  // };

  // /**
  //  * @deprecated
  //  */
  // getStateName = (operations) => {
  //   if (this.props.cleaningProperties.isCleaningWizardRunning) {
  //     for (var operationLine in operations) {
  //       var operation = operations[operationLine];
  //       for (var key in operation) {
  //         if (key === "Running") {
  //           if (operation[key] === true) return operation["Sequence"].replace("_", " ").toUpperCase();
  //         }
  //       }
  //     }
  //     return "PREPARING";
  //   }
  //   return "IDLE";
  // };

  // /**
  //  * @deprecated since the status update was published with signalR web-scoket
  //  * @deprecated
  //  */
  // failedGetStatus = () => { };

  // /**
  //  * @deprecated used {@link TimeRemaining} instead
  //  * @param {Number} totalMinuteInSeconds
  //  * @param {Number} timeElapsed
  //  * @returns
  //  */
  // generateTimeRemaining = (totalMinuteInSeconds, timeElapsed) => {
  //   var TimeRemaining = totalMinuteInSeconds - timeElapsed;
  //   if (TimeRemaining < 0) TimeRemaining = 0;
  //   return this.secondToMinute(TimeRemaining);
  // };

  // /**
  //  * @deprecated used {@link SecondToStringFormat} instead
  //  * @param {Number} time
  //  * @returns
  //  */
  // secondToMinute = (time) => {
  //   var minutes = Math.floor(time / 60);
  //   var seconds = Math.floor(time - minutes * 60);
  //   return COMMONFUNCTION.pad(minutes.toString(), 2) + " minutes " + COMMONFUNCTION.pad(seconds.toString(), 2) + " seconds";
  // };

  // eslint-disable-next-line class-methods-use-this
  generateText = (textPropeties) => {
    let id = 0;
    const showText = textPropeties.map((text) => {
      id += 1;
      return (
        <div
          className="row center"
          key={id}
        >
          <div className="col-md-6 label-style">{text.label}</div>
          <div className="col-md-6 content-style">{text.content}</div>
        </div>
      );
    });
    return showText;
  };

  // eslint-disable-next-line class-methods-use-this
  convertStatusCleainingWizardToDiagramStatus = (status) => {
    switch (status) {
      case APPDATA.DEVICE_STATE.IDLE:
        return Diagram.STATUS.IDLE;
      case APPDATA.DEVICE_STATE.PREPARING:
      case APPDATA.DEVICE_STATE.DEPRESSURIZING:
        return Diagram.STATUS.PREPARING;
      case APPDATA.DEVICE_STATE.BUFFER_RECOVERY:
        return Diagram.STATUS.REVOCERING_BUFFFER;
      case APPDATA.DEVICE_STATE.REVERSE_DIAFILTRATE:
        return Diagram.STATUS.REVERSE_DIAFILTRATING;
      case APPDATA.DEVICE_STATE.PRIME:
        return Diagram.STATUS.PRIMING;
      case APPDATA.DEVICE_STATE.REVERSE_CONCENTRATE:
        return Diagram.STATUS.RECOVERING_AIR;
      case APPDATA.DEVICE_STATE.CONCENTRATE:
        return Diagram.STATUS.CONCENTRATING;
      case APPDATA.DEVICE_STATE.DIAFILTRATION:
      case APPDATA.DEVICE_STATE.DIAFILTRATE:
        return Diagram.STATUS.DIAFILTRRATING;
      default:
        return Diagram.STATUS.IDLE;
    }
  };

  render() {
    const {totalDuration, timeRemaining, status, recomendedVolume} = this.state;
    const textPropeties = [
      {
        label: 'Cleaning Liquid Volume',
        content: `${recomendedVolume} mL`,
      },
      {
        label: 'Cleaning Duration',
        content: totalDuration,
      },
      {
        label: 'Time Remaining',
        content: timeRemaining,
      },
      {
        label: 'Status',
        content: convertCleaningStatusToDisplayString(status),
      },
    ];
    const currentState = this.convertStatusCleainingWizardToDiagramStatus(status);
    return (
      <div className="status-cleaning-wizard">
        <div className="row row-content center cleaning-content">
          <div className="col-md-8 text-content  ">{this.generateText(textPropeties)}</div>
          <div className="col-md-4 diagram-content center ">
            <Diagram
              scaleSize="medium"
              isPaused={false}
              isRunning={this.props.cleaningProperties.isCleaningWizardRunning}
              currentState={currentState.replace(' ', '-')}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default StatusWizard;

// /**
//  * @deprecated
//  * @enum {String}
//  * @see {@link APPDATA.DEVICE_STATE}
//  */
// const STATUS = {
//   IDLE: "IDLE",
//   RUNNING: "RUNNING",
//   PAUSED: "PAUSED",
//   PREPARING: "PREPARING",
//   DEPRESSURIZING: "DEPRESSURIZING",
//   BUFFER_RECOVERY: "BUFFER RECOVERY",
//   REVERSE_DIAFILTRATE: "REVERSE DIAFILTRATE",
//   PRIME: "PRIME",
//   REVERSE_CONCENTRATE: "REVERSE CONCENTRATE",
//   CONCENTRATE: "CONCENTRATE",
// };
// /**
//  * @deprecated
//  * @enum {String}
//  * @see {@link APPDATA.DEVICE_STATE}
//  */
// StatusWizard.STATUS = STATUS;
